export default __webpack_public_path__ + "static/gw2-banner-getting-started-feab74f2fce759baf1012501a7dfa747.png";